/* eslint-disable import/prefer-default-export */
export const companyConstants = {
  GET_COMPANY_REQUEST: 'COMPANIES_GET_COMPANY_REQUEST',
  GET_COMPANY_SUCCESS: 'COMPANIES_GET_COMPANY_SUCCESS',
  GET_COMPANY_FAILURE: 'COMPANIES_GET_COMPANY_FAILURE',

  CREATE_COMPANY_REQUEST: 'COMPANIES_CREATE_COMPANY_REQUEST',
  CREATE_COMPANY_SUCCESS: 'COMPANIES_CREATE_COMPANY_SUCCESS',
  CREATE_COMPANY_FAILURE: 'COMPANIES_CREATE_COMPANY_FAILURE',

  UPDATE_COMPANY_REQUEST: 'COMPANIES_UPDATE_COMPANY_REQUEST',
  UPDATE_COMPANY_SUCCESS: 'COMPANIES_UPDATE_COMPANY_SUCCESS',
  UPDATE_COMPANY_FAILURE: 'COMPANIES_UPDATE_COMPANY_FAILURE',

  DELETE_COMPANY_REQUEST: 'COMPANIES_DELETE_COMPANY_REQUEST',
  DELETE_COMPANY_SUCCESS: 'COMPANIES_DELETE_COMPANY_SUCCESS',
  DELETE_COMPANY_FAILURE: 'COMPANIES_DELETE_COMPANY_FAILURE',

  GET_ALL_COMPANIES_REQUEST: 'COMPANIES_GET_ALL_COMPANIES_REQUEST',
  GET_ALL_COMPANIES_SUCCESS: 'COMPANIES_GET_ALL_COMPANIES_SUCCESS',
  GET_ALL_COMPANIES_FAILURE: 'COMPANIES_GET_ALL_COMPANIES_FAILURE',

  SET_COMPANY: 'COMPANIES_SET_COMPANY',
  UNSET_COMPANY: 'COMPANIES_UNSET_COMPANY',

};
